const dashaboard = {
  path: "/dashboard",
  meta: {
    breadCrumb: "Bem-vindo(a)",
  },
  children: [
    {
      path: "/dashboard",
      name: "dashboard",
      component: () => import("@/views/Dashboard.vue"),
    },
  ],
};

export { dashaboard };
